export default __webpack_public_path__ + "static/media/07_007_Trash_PG.e3bb04fd.svg";